function adev_get_aspect_ratio_by_width_height(width, height) {
    return (width / height) * 100;
}


document.addEventListener('alpine:init', function(){
   

   
    adevAlpine.store('adev_mystery_box_cart', {
        opened: false,
        open() {
            this.opened = true;
        },
        close() {
            this.opened = false;
        },
        items: [],
        get_items() {
            return this.items;
        },
        get_goal_count() {
            return window.adev_mystery_box.goal_count;
        },
        get_cart_count() {
            return this.items.reduce((acc, item) => {
                return acc + item.quantity;
            }, 0);
        },
        add_to_cart(item) {
            const existingItem = this.items.find(i => i.id === item.id && i.variant_id === item.variant_id);
            if (existingItem) {
                this.items = this.items.map(i => {
                    if (i.id === item.id && i.variant_id === item.variant_id) {
                        i.quantity += 1;
                    }
                    return i;
                });
            } else {
                this.items.push(item);
            }
        },
        remove_from_cart(item) {
            this.items = this.items.filter(i => i.variant_id !== item.variant_id);
        },
        reached_goal() {
            return this.get_cart_count() >= this.get_goal_count();
        },
        init() {
            adevAlpine.effect(() => {
                if (this.reached_goal()) {
                    // open the cart drawer when the goal is reached
                    this.open();
                }
            });
        }
    });

    adevAlpine.data('adev_mystery_box_stats', function(){
        return {
            get_text(){
                const translations = window.adev_mystery_box.translations;
                const store = adevAlpine.store('adev_mystery_box_cart');
                const goal_count = store.get_goal_count();
                const cart_count = store.get_cart_count();

                return translations.stats_message.replace('[selected]', cart_count).replace('[goal]', goal_count);
            },
            finished(){
                const store = adevAlpine.store('adev_mystery_box_cart');
                return store.reached_goal();
            },
            has_selected_items(){
                const store = adevAlpine.store('adev_mystery_box_cart');
                return store.get_cart_count() > 0;
            },
            open_cart_drawer(){
                const store = adevAlpine.store('adev_mystery_box_cart');
                store.open();
            },
            init(){
                const fix_position = () => {
                    document.documentElement.style.setProperty('--adev-mystery-box-stats-height', `${this.$root.scrollHeight}px`);
                }

                fix_position();

                window.addEventListener('scroll', fix_position);
                window.addEventListener('resize', fix_position);
            },
        }
    });
    

    adevAlpine.data('adev_mystery_box', function(){
        return {
            finished(){
                const store = adevAlpine.store('adev_mystery_box_cart');
                return store.reached_goal();
            },
            add_to_cart($el){
                const store = adevAlpine.store('adev_mystery_box_cart');

                if (store.reached_goal()) return;

                const id = parseInt($el.dataset.id);

                const product = window.adev_mystery_box.products.find(product => product.id === id);
                if (!product) return;

                const title = product.title;
                const sku = product.sku;
                const imgSrc = product.image_250x;
                const variant = product.variants[0];
                const width = product.image_width;
                const height = product.image_height;

                const item = {
                    id: id,
                    quantity: 1,
                    title: title,
                    sku: sku,
                    imgSrc: imgSrc,
                    has_variants: product.has_variants,
                    variant_id: variant.id,
                    variant_title: variant.title,
                    variant_sku: variant.sku,
                    aspect_ratio: adev_get_aspect_ratio_by_width_height(width, height),
                }

                store.add_to_cart(item);
            },
            choose_variant($el){
                const quickview_store = adevAlpine.store('adev_mystery_box_quickview');
                
                const id = parseInt($el.dataset.id);
                const product = window.adev_mystery_box.products.find(product => product.id === id);
                if (!product) return;

                quickview_store.set_product(product);
                quickview_store.open();
            },
            get_add_to_cart_button_text(){
                const store = adevAlpine.store('adev_mystery_box_cart');
                const translations = window.adev_mystery_box.translations;
                return store.reached_goal() ? translations.box_full : translations.add_to_cart;
            },

            ripple($el){
                $el.classList.add('adev-ripple');

                setTimeout(() => {
                    $el.classList.remove('adev-ripple');
                }, 250);
            }
        }
    });

    adevAlpine.store('adev_mystery_box_quickview', {
        opened: false,
        open() {
            this.opened = true;
        },
        close() {
            this.opened = false;
        },

        product: null,
        current_variant: null,
        options: null,
        set_product(product) {
            this.product = product;

            this.current_variant = product.variants[0];
            this.options = [...this.current_variant.options];
        },
        get_product() {
            return this.product;
        },
        get_selected_variant() {
            return this.current_variant;
        },
        unset_product() {
            this.product = null;
            this.current_variant = null;
        }
    });

    adevAlpine.data('adev_mystery_box_quickview', function(){
        return {
            is_open(){
                return adevAlpine.store('adev_mystery_box_quickview').opened;
            },
            close(){
                const store = adevAlpine.store('adev_mystery_box_quickview');
                store.close();
                store.unset_product();
            },
            get_title(){
                const store = adevAlpine.store('adev_mystery_box_quickview');
                const product = store.get_product();
                return product ? product.title : '';
            },
            get_image_aspect_ratio(){
                const store = adevAlpine.store('adev_mystery_box_quickview');
                const product = store.get_product();
                return product ? adev_get_aspect_ratio_by_width_height(product.image_width, product.image_height) : 100;
            },
            get_image(){
                const store = adevAlpine.store('adev_mystery_box_quickview');
                const product = store.get_product();
                return product ? product.image_500x : '';
            },
            has_variants(){
                const store = adevAlpine.store('adev_mystery_box_quickview');
                const product = store.get_product();
                return product ? product.has_variants : false;
            },
            get_options(){
                const store = adevAlpine.store('adev_mystery_box_quickview');
                const product = store.get_product();
                return product ? product.options : [];
            },
            get_sku(){
                const store = adevAlpine.store('adev_mystery_box_quickview');
                const product = store.get_product();
                return product ? product.sku : '';
            },
            has_selected_variant(){
                const store = adevAlpine.store('adev_mystery_box_quickview');
                return store.current_variant !== null;
            },
            get_selected_variant(){
                const store = adevAlpine.store('adev_mystery_box_quickview');
                return store.current_variant;
            },
            disable_atc(){
                const store = adevAlpine.store('adev_mystery_box_quickview');
                const cart_store = adevAlpine.store('adev_mystery_box_cart');
                return store.current_variant === null || store.current_variant.available === false || cart_store.reached_goal();
            },
            update_variant($el, index){
                const store = adevAlpine.store('adev_mystery_box_quickview');
                store.options[index] = $el.value;

                store.current_variant = store.product.variants.find(variant => {
                    return !variant.options.map((option, i) => {
                        return store.options[i] === option;
                    }).includes(false);
                });
            },
            get_add_to_cart_text(){
                const store = adevAlpine.store('adev_mystery_box_quickview');

                if (store.current_variant === null) {
                    return 'Select an option';
                }

                if (store.current_variant.available === false) {
                    return 'Sold Out';
                }

                const cart_store = adevAlpine.store('adev_mystery_box_cart');
                if (cart_store.reached_goal()) {
                    return 'Box Full';
                }

                return 'Add to Cart';
            },
            add_to_cart($el){
                const store = adevAlpine.store('adev_mystery_box_cart');
                const quickview_store = adevAlpine.store('adev_mystery_box_quickview');

                if (store.reached_goal()) return;

                const product = quickview_store.get_product();
                if (!product) return;

                const variant = quickview_store.get_selected_variant();
                const title = product.title;
                const sku = variant.sku ? variant.sku : sku;
                const imgSrc = product.image_250x;
                const width = product.image_width;
                const height = product.image_height;

                const item = {
                    id: product.id,
                    quantity: 1,
                    title: title,
                    sku: sku,
                    imgSrc: imgSrc,
                    has_variants: product.has_variants,
                    variant_id: variant.id,
                    variant_title: variant.title,
                    variant_sku: variant.sku,
                    aspect_ratio: adev_get_aspect_ratio_by_width_height(width, height),
                }

                store.add_to_cart(item);

                quickview_store.close();
                quickview_store.unset_product();
            },
            ripple($el){
                $el.classList.add('adev-ripple');

                setTimeout(() => {
                    $el.classList.remove('adev-ripple');
                }, 250);
            }
        }
    });
    
    adevAlpine.data('adev_mystery_box_cart_drawer', function(){
        return {
            is_open(){
                return adevAlpine.store('adev_mystery_box_cart').opened;
            },
            close(){
                const store = adevAlpine.store('adev_mystery_box_cart');
                store.close();
            },
            get_progress(){
                const store = adevAlpine.store('adev_mystery_box_cart');
                const translations = window.adev_mystery_box.translations;
                const progress_text = translations.cart_progress;

                return progress_text.replace('[selected]', store.get_cart_count()).replace('[goal]', store.get_goal_count());
            },
            get_items(){
                const store = adevAlpine.store('adev_mystery_box_cart');
                return store.items;
            },
            get_image_aspect_ratio(item){
                return item.aspect_ratio;
            },
            get_image(item){
                return item.imgSrc;
            },
            get_title(item){
                return item.title + (item.has_variants ? ' - ' + item.variant_title : '');
            },
            get_sku(item){
                return item.sku;
            },
            get_qty(item){
                return 'x' + item.quantity;
            },
            remove_item(product){
                const store = adevAlpine.store('adev_mystery_box_cart');
                store.remove_from_cart(product);

                if (store.get_cart_count() < 1) {
                    store.close();
                }
            },
            disable_atc(){
                const store = adevAlpine.store('adev_mystery_box_cart');
                
                if (!store.reached_goal()) {
                    return true;
                }

                if (this.loading_state) {
                    return true;
                }

                return false;
            },
            get_add_button_text(){
                const translations = window.adev_mystery_box.translations;
                const store = adevAlpine.store('adev_mystery_box_cart');
                return store.reached_goal() ? translations.cart_atc : translations.cart_select_options;
            },
            ripple($el){
                $el.classList.add('adev-ripple');

                setTimeout(() => {
                    $el.classList.remove('adev-ripple');
                }, 250);
            },
            loading_state: false,
            add_product_to_cart($el){
                const store = adevAlpine.store('adev_mystery_box_cart');
                const translations = window.adev_mystery_box.translations;
                const cart_items = store.get_items();
                

                const product_id = window.adev_mystery_box.product;
                if (!product_id) {
                    alert('Main product not found');
                    return;
                }

                this.loading_state = true;

                const formData = new FormData();
                formData.append('id', product_id);
                formData.append('quantity', 1);

                cart_items.forEach((item, index) => {
                    let index1 = index + 1;
                    formData.append(`properties[_ID ${index1}]`, item.id);
                    formData.append(`properties[${translations.product_term} ${index1}]`, 
                        item.title + (item.has_variants ? ' - ' + item.variant_title : '') + ' (x' + item.quantity + ')'
                    );
                    formData.append(`properties[_SKU ${index1}]`, item.sku);
                });

                fetch('/cart/add.js', {
                    method: 'POST',
                    body: formData,
                })
                .then(resp => resp.json())
                .then(data => {
                    document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", {
                        bubbles: true
                    }));

                    setTimeout(() => {
                        document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open", {
                            bubbles: true
                        }));

                        store.close();
                    }, 500);

                    setTimeout(() => {
                        this.loading_state = false;
                    }, 1000);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    alert(error.description)

                    this.loading_state = false;
                });

            }
        }
    });
    
    
});